module.exports = __webpack_public_path__ + "img/chevron-down.1c9b2615.svg";